var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page",staticStyle:{"overflow":"auto"}},[_c('router-view'),_c('notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }